import { Card, Grid, Loader } from "@mantine/core";
import {
  isPhone,
  WIDGET_IFRAME_SRC,
  WIDGET_PROVIDER_ID,
} from "../../../../../constants/env";
import { useUser } from "../../../../../hooks/react-query/useUser";
import classes from "./appointment.module.css";
import { useColors } from "../../../../../hooks/colors/useColors";
import { useEffect, useState } from "react";
import { MyH1 } from "../../../../UI/my-h1/MyH1";
import { useScheduleList } from "../../../../../hooks/react-query/useSchedules";
import { StepperButtons } from "./StepperButtons";
import {
  BookingForm,
  bookingStore,
} from "../../../../config/store/bookingStore";

export function ThirdStep() {
  const { user } = useUser();
  const { schedules } = useScheduleList();
  const [iframeIsLoading, setIframeIsLoading] = useState<boolean>(true);
  const { colors, isDarkMode } = useColors();
  const [message, setMessage] = useState<string | undefined>();
  const {
    updateIndex,
    stepperFields,
    updateBookingForm,
    activeIndex,
    bookingForm,
  } = bookingStore((state) => state);

  function showSpecialistName() {
    if (schedules && schedules.length > 0) {
      if (stepperFields.specialist) {
        return stepperFields.specialist.name;
      } else {
        return "";
      }
    } else {
      return "";
    }
  }

  useEffect(() => {
    const handler = (ev: MessageEvent<{ type: string; message: string }>) => {
      if (typeof ev.data !== "object") return;
      if (!ev.data.type) return;
      if (ev.data.type !== "button-click") return;
      if (!ev.data.message) return;
      setMessage(ev.data.message);
    };

    window.addEventListener("message", handler);

    // Don't forget to remove addEventListener
    return () => window.removeEventListener("message", handler);
  }, []);

  useEffect(() => {
    if (message) {
      updateIndex(activeIndex + 1);
      const form: BookingForm = JSON.parse(message);
      updateBookingForm(form);
    }
  }, [activeIndex, message, updateBookingForm, updateIndex]);

  return (
    <div>
      {stepperFields.specialist && (
        <Grid className="mb-6">
          <Grid.Col span={12} className="my-6">
            <MyH1 centerText size="2.5rem">
              <span className="w-full">
                {showSpecialistName()}
                {stepperFields.services.length > 0 && (
                  <span>
                    {` / ${stepperFields.services
                      .map((service) => service.service)
                      .join(", ")}`}
                  </span>
                )}
              </span>
            </MyH1>
          </Grid.Col>
          <Grid.Col span={12}>
            <Card
              shadow="md"
              p="lg"
              radius="md"
              withBorder
              className="!p-0"
              // style={{ backgroundColor: colors.background }}
            >
              {iframeIsLoading && (
                <div
                  className="h-full flex justify-center items-center absolute top-0 w-full"
                  style={{ height: isPhone ? "100vh" : "36rem" }}
                >
                  <Loader />
                </div>
              )}
              <iframe
                onLoad={() => setIframeIsLoading(false)}
                style={{
                  height: isPhone ? "100vh" : "50rem",
                  display: "flex",
                  alignItems: "center",
                }}
                className={classes.frame + " w-full"}
                src={`${WIDGET_IFRAME_SRC}/pt/widget?provider_id=${WIDGET_PROVIDER_ID}&customer_name=${
                  user && user.user ? user.user.displayName : ""
                }&schedule_id=${
                  stepperFields.specialist.id
                }&dark_mode=${isDarkMode}
                &services=${JSON.stringify(stepperFields.services)}
                `}
              />
            </Card>
          </Grid.Col>
          <Grid.Col
            span={{ base: 12, md: 6 }}
            className="flex justify-center"
          ></Grid.Col>
        </Grid>
      )}
      <StepperButtons
        disabled={typeof bookingForm === "undefined"}
        disableForward
      />
    </div>
  );
}
